import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from 'src/app/dashboard/dashboard.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { TimezoneService } from 'src/app/reusables/services/timezone.service';
import { SubmitFeedbackComponent } from '../submit-feedback/submit-feedback.component';

@Component({
    selector: 'cv-navigation-header-menu',
    templateUrl: './navigation-header-menu.component.html',
    styleUrl: './navigation-header-menu.component.scss',
})
export class NavigationHeaderMenuComponent implements OnInit {
    defaultProfileImage: string = "/Admin/NoProfileImageLetters.aspx?nl=?&w=90&h=90";
    openSubmenu: string ="";
    canResetDemo: boolean = false;

    constructor(
    public navigationService: NavigationService,
    public timezoneService: TimezoneService,
    public dashboardService: DashboardService,
    public cvApiService: CVApiService,
    private modalService: NgbModal
    ) { }

    async ngOnInit(){
        this.canResetDemo = await this.dashboardService.canResetDemo();
    }

    getImageSource(): string{
        if(this.navigationService.loggedInImageSource)
            return this.navigationService.loggedInImageSource;
        else
            return this.defaultProfileImage;
    }

    toggleSubmenu(menu: string){
        if(this.openSubmenu === menu)
            this.openSubmenu = "";
        else
            this.openSubmenu = menu;
    }

    showLanguageInHeader(): boolean{
        if(this.navigationService.companyPartner == null || this.navigationService.companyPartner > -1) return true;
        else return false;
    }

    toggleUserProfile($event: MouseEvent){
        $event.stopPropagation();
        this.navigationService.$uibModal?.open({
            animation: true,
            appendTo: angular.element('.contentWrapper'),
            component:  'userProfileMain',
            openedClass: 'stopScrolling',
            size: 'xl modal-dialog-noborder-when-loading modal-dialog-centered',
        });
    };

    openSubmitFeedback(){
        this.modalService.open(
            SubmitFeedbackComponent,
            {size:'md-lg',
                modalDialogClass:'modal-dialog-centered modal-dialog-noborder-when-loading',
                animation:true });
    }

    async endImpersonateUser(){
        await this.navigationService.endImpersonateUser();
        this.redirect("../Dashboard/DashboardNew.aspx");
    }

    redirect(url: string){
        window.location.replace(url);
    }

    selectedTimezone(timezone): boolean {
        return this.timezoneService.dataObj != null && this.timezoneService.dataObj.selectedTimeZone === timezone;
    }

    noAvailableTimezones(): boolean {
        return this.timezoneService.dataObj == null
        || (this.timezoneService.dataObj?.availableTimeZones.length === 1 && this.timezoneService.dataObj.selectedTimeZone === 'Not Set');
    }

    onImageError(){
        this.navigationService.loggedInImageSource = this.defaultProfileImage;
    }
}
